// SMSAPI.js
import apiClient from "../../../../services/apiClient";

export const SMSAPI = {
  getNotifications: async ({ phone, date_from, date_to, request_id }) => {
    try {
      const params = new URLSearchParams();
      
      if (phone) params.append('phone', phone);
      if (date_from) params.append('date_from', date_from);
      if (date_to) params.append('date_to', date_to);
      if (!date_to && date_from) params.append('date_to', new Date().toISOString().split('T')[0]);
      if (request_id) params.append('request_id', request_id);

      const link = `notifications_info?${params.toString()}`;
      const response = await apiClient.get(link);

      if (response.data) {
        return { success: true, data: response.data };
      }
      
      return { success: false, error: 'No data received' };
    } catch (error) {
      console.error('Error fetching SMS notifications:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  sendTestSMS: async (phone) => {
    try {
      const params = new URLSearchParams({
        code: '23kjhds434ds',
        phone: phone
      });

      const link = `test/sms?${params.toString()}`;
      const response = await apiClient.get(link);

      if (response.data) {
        return { success: true, data: response.data };
      }
      
      return { success: false, error: 'No data received' };
    } catch (error) {
      console.error('Error sending test SMS:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  }
};